export default "__VITE_ASSET__Do7PNUrL__"